/**
 * Shared layout for Legal pages (Privacy, Terms).
 * Matches IdeaWeave warm paper aesthetic.
 */

import React from "react";

interface LegalPageLayoutProps {
  title: string;
  backHref: string;
  dark?: boolean;
  children: React.ReactNode;
}

export const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({
  title,
  backHref,
  dark = false,
  children,
}) => {
  return (
    <div className={`legal-page${dark ? " dark" : ""}`}>
      <header className="legal-page__header">
        <a href={backHref} className="legal-page__logo">
          <span className="material-symbols-outlined">lightbulb</span>
          IdeaWeave
        </a>
        <a href={backHref} className="legal-page__back">
          <span
            className="material-symbols-outlined"
            style={{ fontSize: "1rem" }}
          >
            arrow_back
          </span>
          Back
        </a>
      </header>

      <main className="legal-page__content">
        <h1 className="legal-page__title">{title}</h1>
        {children}
      </main>
    </div>
  );
};
